import { render, staticRenderFns } from "./LicenseInformation.vue?vue&type=template&id=4556717a&"
import script from "./LicenseInformation.vue?vue&type=script&lang=js&"
export * from "./LicenseInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports